import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const messageCreated = gql`
  subscription ThreadMessageCreatedSubscription($input: ThreadMessageSubscription!) {
    message: threadMessageCreated(input: $input) {
      ...ThreadMessage
    }
  }

  ${Fragments.thread.message}
`;

export const messageUpdated = gql`
  subscription ThreadMessageUpdatedSubscription($input: ThreadMessageSubscription!) {
    message: threadMessageUpdated(input: $input) {
      ...ThreadMessage
    }
  }

  ${Fragments.thread.message}
`;

export const messageDeleted = gql`
  subscription ThreadMessageDeletedSubscription($input: ThreadMessageSubscription!) {
    message: threadMessageDeleted(input: $input) {
      ...ThreadMessage
    }
  }

  ${Fragments.thread.message}
`;

export const seenBy = gql`
  subscription ThreadSeenBySubscription($input: ThreadSubscription!) {
    thread: threadUpdated(input: $input) {
      ...ThreadWithMembershipsAndMessageCount
    }
  }

  ${Fragments.thread.memberships}
`;
